import { render, staticRenderFns } from "./myEditor.vue?vue&type=template&id=996e1276&"
import script from "./myEditor.vue?vue&type=script&lang=js&"
export * from "./myEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports